import { render, staticRenderFns } from "./SiteOptions.vue?vue&type=template&id=2bec036e&scoped=true&"
import script from "./SiteOptions.vue?vue&type=script&lang=js&"
export * from "./SiteOptions.vue?vue&type=script&lang=js&"
import style0 from "./SiteOptions.vue?vue&type=style&index=0&id=2bec036e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec036e",
  null
  
)

export default component.exports